import { Skeleton, Stack} from "@mui/material"
import { BoxPanel } from "screens/styles";

export const QuestionMultiSkeleton = () => {
  return (
    <BoxPanel className="BoxShadow">
      <Stack gap={3}>

          <Stack gap={2} width={'100%'}>
            <Skeleton variant='text' sx={{borderRadius:8, width:'32%', backgroundColor:'#E9ECF5'}}/>
            <Skeleton variant='text' sx={{borderRadius:8, width:'64%', backgroundColor:'#E9ECF5'}}/>
          </Stack>
          <Stack direction='column' gap={3} >
            <Stack direction='row' sx={{alignItems:'start', gap:1 }}>
              <Skeleton variant='rectangular' sx={{borderRadius:8, height:32, aspectRatio:1, backgroundColor:'#E9ECF5'}}/>
              <Skeleton variant='rectangular' sx={{borderRadius:8, flex:1, height:52, backgroundColor:'#E9ECF5'}}/>
            </Stack>
            <Stack direction='row' sx={{alignItems:'start', gap:1 }}>
              <Skeleton variant='rectangular' sx={{borderRadius:8, height:32, aspectRatio:1, backgroundColor:'#E9ECF5'}}/>
              <Skeleton variant='rectangular' sx={{borderRadius:8, flex:1, height:52, backgroundColor:'#E9ECF5'}}/>
            </Stack>
            <Stack direction='row' sx={{alignItems:'start', gap:1 }}>
              <Skeleton variant='rectangular' sx={{borderRadius:8, height:32, aspectRatio:1, backgroundColor:'#E9ECF5'}}/>
              <Skeleton variant='rectangular' sx={{borderRadius:8, flex:1, height:52, backgroundColor:'#E9ECF5'}}/>
            </Stack>
        </Stack>
      </Stack>
    </BoxPanel>
  )
}
